import { LOCATION_FINDER_INPUT } from 'constant'

export default (inputValue, { useMyLocationClicked }) => {
  const errors = {}
  if (!(inputValue[LOCATION_FINDER_INPUT] &&
    inputValue[LOCATION_FINDER_INPUT].trim().length) &&
    !useMyLocationClicked) {
    errors[LOCATION_FINDER_INPUT] = 'Please enter a valid city and state or zip code.'
  }
  return errors
}
